import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { SharedModule } from '@app/shared';
import { WhitelabelRoutingModule } from './whitelabel-routing.module';
import { WaitingroomComponent } from './waitingroom/waitingroom.component';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [WaitingroomComponent],
  imports: [CommonModule, RouterModule, SharedModule, WhitelabelRoutingModule, TranslateModule, NgbModule]
})
export class WhitelabelModule {}
